import { AdPlacements } from "./AdPlacements";

export const AdIDs = {
    [AdPlacements.INTERSTITIAL]: "",
    [AdPlacements.BANNER]: "",
    [AdPlacements.REWARDED]: "",
};
